import { SWITCH_THEME } from "@/redux/types";

export const toggleThemeHandler = () => ({ type: SWITCH_THEME });
